import { createSlice } from "@reduxjs/toolkit";
import { monerisCardCreate, monerisCardGet, paymentOptionUpdate, paymentGetSwitch } from "redux/service/settingsService/monerisService";

const initialState = {
  cardGet: { data: [], isFetching: false, error: null },
  cardCreate: { data: [], isFetching: false, error: null },
  paymentWay: { data: [], isFetching: false, error: null },
  paymentOption: { data: [], isFetching: false, error: null },
};

export const monerisSlice = createSlice({
  name: "moneris",
  initialState,
  extraReducers: (builder) => {
    const asyncActionCases = [
      { api: monerisCardGet, name: "cardGet" },
      { api: monerisCardCreate, name: "cardCreate" },
      { api: paymentGetSwitch, name: "paymentWay" },
      { api: paymentOptionUpdate, name: "paymentOption" },
    ];

    asyncActionCases.forEach((asyncAction) => {
      builder
        .addCase(asyncAction.api.fulfilled, (state, { payload }) => {
          state[asyncAction.name].isFetching = false;
          state[asyncAction.name].data = payload;
        })
        .addCase(asyncAction.api.pending, (state) => {
          state[asyncAction.name].isFetching = true;
          state[asyncAction.name].error = null;
        })
        .addCase(asyncAction.api.rejected, (state, { payload }) => {
          state[asyncAction.name].isFetching = false;
          state[asyncAction.name].error = payload;
        });
    });
  }
});

export const { actions } = monerisSlice;
export default monerisSlice.reducer;